import React, { FC, RefObject, useEffect, useRef, useState } from 'react'
import text from 'styles/utility/text.module.scss'
import { OrderType } from 'types/checkout'
import { FlexRow } from 'components/Flex'
import { Checkbox } from 'components/Form'
import { HorizontalLine, Spacer } from 'components/Utility'
import { findBreadShortName } from 'lib/helper'
import { DefaultStockType, ScheduleType } from 'types/schedule'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { getSchedules } from 'reducks/schedule/selectors'
import { getBreads } from 'reducks/bread/selectors'

type Props = {
  order: OrderType
}

const PrintOrderBody: FC<Props> = (props) => {
  const { order } = props
  const breads = useSelector((state: State) => getBreads(state))
  const schedules: ScheduleType[] = useSelector((state: State) => getSchedules(state))

  const [minWidth, setMinWidth] = useState<number>(0)

  const refs = useRef<RefObject<HTMLDivElement>[]>([])
  order.items.map((_, i) => (refs.current[i] = React.createRef()))

  useEffect(() => {
    if (!refs.current) return
    const max = Math.max(...refs.current.map((ref) => ref.current?.clientWidth || 0))
    setMinWidth(max)
  }, [refs.current])

  return (
    <>
      {order.items
        .sort((a, b) => {
          const aBread = breads.find((bread) => bread.bread_ref?.id === a.bread_ref.id)
          const bBread = breads.find((bread) => bread.bread_ref?.id === b.bread_ref.id)
          // bread の order の昇順で並び替える
          return (aBread?.order || 9999) - (bBread?.order || 9999)
        })
        .map((item, i) => {
          // 引当在庫数判定の改修によりquantityが0の場合もありえるが非表示とする
          if (!item.checkout_item_ref || item.quantity === 0) return
          const defaultStocks = schedules
            .filter((schedule) => item.bread_ref.id === schedule.bread_ref.id && item.type === schedule.type)
            .reduce((prev: DefaultStockType[], schedule) => {
              return [...prev, ...schedule.default_stocks]
            }, [])
          const pickupableTimeLabel = defaultStocks.length > 1 ? ` （${item.pickupable_time}受渡解禁分）` : ''
          const choiceLabel = item.choice ? '\n' + item.choice : ''
          const breadName = findBreadShortName(breads, item.bread_name, item.bread_ref)
          const label = breadName + pickupableTimeLabel + choiceLabel
          return (
            <React.Fragment key={item.checkout_item_ref.id}>
              {i === 0 && <HorizontalLine color={'grey04'} verticalMargin={8} />}
              <FlexRow justifyContent={'start'}>
                <div ref={refs.current[i]} style={{ minWidth }}>
                  <Checkbox
                    disabled={true}
                    fontSize={16}
                    id={item.checkout_item_ref.id}
                    isChecked={false}
                    label={label}
                  />
                </div>
                <Spacer size={48} axis={'horizontal'} />
                <p className={text.font_mediumLarge} style={{ minWidth: '40px' }}>
                  {item.quantity}個
                </p>
              </FlexRow>
              {order.items.length !== i + 1 && <HorizontalLine color={'grey04'} verticalMargin={8} />}
            </React.Fragment>
          )
        })}
    </>
  )
}

export default PrintOrderBody
